import categoryAPI from '@/services/api/inventory/category'
import ObjectUtil from '@/utils/modules/ObjectUtil'
import StringUtils from '@/utils/modules/StringUtils'

const index = {
	namespaced: true,
	state: () => ({
		mode: 'normal',
		categoryInfo: null,

		inventoryForm: {
			basicInfo: {
				brandId: null,
				brandName: null,
				productCode: null,
				name: '',
				subname: '',
				casno: '',
				volume: null,
				volumeUnit: 'kg',
				storageId: null,
				categoryId: null,
				multiCreateCount: 1,
				ingredient: [],
			},

			managementInfo: {
				incompanyMngcode: '',
				lotno: '',
				registerMethod: 'MANUAL_DIRECT',
				assigneeId: null,
				buyerId: null,
				buyDatetime: new Date().toISOString(),
				price: null,
				priceUnit: 'KRW',
				qrSticker: '',
				memo: null,
				tagsId: [],
				currentVolume: null,
				threshold: null,
				thresholdUnit: 'kg',
				expireDatetime: new Date(
					new Date().setDate(new Date().getDate() + 1)
				).toISOString(),
				openDatetime: new Date().toISOString(),
			},

			customFields: [],
			imageFiles: [],
		},

		inventoryData: {
			categoryType: null,

			brandId: null,
			brandName: null,
			productCode: null,
			name: '',
			subname: '',
			casno: '',
			volume: null,
			volumeUnit: 'kg',
			storageId: null,
			categoryId: null,
			multiCreateCount: 1,
			ingredient: [],

			incompanyMngcode: '',
			lotno: '',
			registerMethod: 'MANUAL_DIRECT',
			assigneeId: null,
			buyerId: null,
			buyDatetime: new Date().toISOString(),
			price: null,
			priceUnit: 'KRW',
			qrSticker: '',
			memo: null,
			tagsId: [],
			currentVolume: null,
			threshold: null,
			thresholdUnit: 'kg',
			expireDatetime: new Date(
				new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
					9
				)
			).toISOString(),
			openDatetime: new Date(new Date().setHours(9)).toISOString(),
			customFields: [],
		},
		images: [],
		brand: null,
		buyer: null,
		assignee: null,
		storage: null,
		ingredientList: [],
		completeInfoDetail: false,
		registerMethod: 'MANUAL_DIRECT',
	}),

	getters: {
		getProductInfo: state => {
			const { name, subname, casno, volume, volumeUnit, productCode } =
				state.inventoryData
			return ObjectUtil.deepCopy({
				brand: state.brand,
				name: name,
				subname: subname,
				casno: casno,
				volume: volume,
				volumeUnit: volumeUnit,
				productCode: productCode,
			})
		},
		getInventoryDetailInfo: state => {
			const {
				threshold,
				thresholdUnit,
				expireDatetime,
				lotno,
				incompanyMngcode,
				currentVolume,
				openDatetime,
				buyDatetime,
				tagsId,
				assigneeId,
				buyerId,
				price,
				priceUnit,
				storageId,
				memo,
			} = state.inventoryData
			return JSON.parse(
				JSON.stringify({
					threshold: threshold,
					thresholdUnit: thresholdUnit,
					expireDatetime: expireDatetime,
					openDatetime: openDatetime,
					lotno: lotno,
					incompanyMngcode: incompanyMngcode,
					assigneeId: assigneeId,
					buyerId: buyerId,
					buyDatetime: buyDatetime,
					price: price,
					priceUnit: priceUnit,
					storageId: storageId,
					memo: memo,
					currentVolume: currentVolume,
					tagsId: tagsId,
				})
			)
		},
		getFormData: state => {
			const body = StringUtils.jsonToMultiform(state.inventoryData)
			const resultFormData = new FormData()
			const inventoryData = body
			const keys = Object.keys(inventoryData)

			for (let i = 0; i < keys.length; i++) {
				const key = keys[i]
				const item = inventoryData[key]
				resultFormData.append(key, item)
			}

			if (keys.indexOf('categoryId') < 0) {
				resultFormData.append('categoryId', state.categoryInfo.id)
			}

			// Images 설정
			for (let i = 0; i < state.images.length; i++) {
				resultFormData.append('images', state.images[i])
			}
			return resultFormData
		},
	},
	mutations: {
		initInventoryData: state => {
			state.inventoryData = {
				multiCreateCount: 1,
				name: '',
				storageId: null,
				categoryId: null,
				categoryType: null,
				incompanyMngcode: '',
				lotno: '',
				registerMethod: 'MANUAL_DIRECT',
				assigneeId: null,
				buyerId: null,
				buyDatetime: new Date().toISOString(),
				price: null,
				priceUnit: 'KRW',
				qrSticker: '',
				memo: null,
				tagsId: [],
				subname: '',
				casno: '',
				productCode: null,
				volume: null,
				volumeUnit: 'kg',
				currentVolume: null,
				threshold: null,
				thresholdUnit: 'kg',
				expireDatetime: new Date(
					new Date(
						new Date().setDate(new Date().getDate() + 1)
					).setHours(9)
				).toISOString(),
				openDatetime: new Date(new Date().setHours(9)).toISOString(),
				brandId: null,
				ingredient: [],
				brandName: null,
			}
			;(state.brand = {
				id: '',
				name: '',
			}),
				(state.assignee = {
					id: '',
					name: '',
				})
			;(state.buyer = {
				id: '',
				name: '',
			}),
				(state.storage = {
					id: '',
					name: '',
				}),
				(state.images = [])
			state.completeInfoDetail = false
			state.ingredientList = []
		},
		setProductInfo: (state, payload) => {
			console.log(state.categoryInfo)
			if (payload.mode === 'AUTO_IMAGE') {
				state.images = payload.images
			} else {
				state.brand = payload.brand

				if (payload.brand) {
					state.inventoryData.brandId = payload.brand.id
				}

				state.inventoryData.name = payload.name
				state.inventoryData.subname = payload.subname
				state.inventoryData.casno = payload.casno
				state.inventoryData.volume = payload.volume
				state.inventoryData.volumeUnit = payload.volumeUnit
				state.inventoryData.productCode = payload.productCode
			}

			// JJ Version
			// basicInfo : {
			// 	brandId: null,
			// 	brandName: null,
			// 	productCode: null,
			// 	name: '',
			// 	subname: '',
			// 	casno: '',
			// 	volume: null,
			// 	volumeUnit: 'kg',
			// 	storageId: null,
			// 	categoryId: null,
			// 	multiCreateCount: 1,
			// 	ingredient: [],
			// }
			// state.inventoryForm.basicInfo.brnadId = payload.brand.id
			// state.inventoryForm.basicInfo.brandName = payload.brand.name;
			// state.inventoryForm.basicInfo.productCode = payload.productCode
			// state.inventoryForm.basicInfo.name = payload.name
			// state.inventoryForm.basicInfo.subname = payload.subname
			// state.inventoryForm.basicInfo.casno = payload.casno
			// state.inventoryForm.basicInfo.volume = payload.volume
			// state.inventoryForm.basicInfo.volumeUnit = payload.volumeUnit
		},
		setInventoryDataDetail: (state, payload) => {
			const {
				threshold,
				thresholdUnit,
				expireDatetime,
				openDatetime,
				lotno,
				incompanyMngcode,
				assigneeId,
				buyerId,
				buyDatetime,
				price,
				priceUnit,
				storageId,
				memo,
				currentVolume,
				tagsId,
			} = payload
			state.inventoryData.threshold = threshold
			state.inventoryData.thresholdUnit = thresholdUnit
			state.inventoryData.expireDatetime = expireDatetime
			state.inventoryData.openDatetime = openDatetime
			state.inventoryData.lotno = lotno
			state.inventoryData.incompanyMngcode = incompanyMngcode
			state.inventoryData.assigneeId = assigneeId
			state.inventoryData.buyerId = buyerId
			state.inventoryData.buyDatetime = buyDatetime
			state.inventoryData.price = price
			state.inventoryData.priceUnit = priceUnit
			state.inventoryData.storageId = storageId
			state.inventoryData.memo = memo
			state.inventoryData.currentVolume = currentVolume
			state.inventoryData.tagsId = [...tagsId]
		},
		setCategoryInfo: (state, payload) => {
			state.categoryInfo = payload
		},
		setMultiCreateCount: (state, payload) => {
			state.inventoryData.multiCreateCount = payload
		},
		setIngredient: (state, payload) => {
			state.inventoryData.ingredient = [...payload]
		},
		removeIngredient: (state, payload) => {
			state.inventoryData.ingredient =
				state.inventoryData.ingredient.filter(
					(item, index) => index !== payload
				)
		},
		setBrand: (state, payload) => {
			state.inventoryData.brandId = payload.id
			state.brand = payload
		},
		setBrandName: (state, payload) => {
			state.inventoryData.brandName = payload
			state.brand = {
				name: payload,
				id: null,
				image: null,
			}
		},
		setInventoryData: (state, payload) => {
			state.inventoryData = ObjectUtil.deepCopy(payload)
		},
		setRegisterMethod: (state, payload) => {
			state.inventoryData.registerMethod = payload
			state.registerMethod = payload
		},
		setFormBuyer: (state, payload) => {
			state.inventoryData.buyerId = payload.id
			state.buyer = payload
		},
		setFormAssignee: (state, payload) => {
			state.inventoryData.assigneeId = payload.id
			state.assignee = payload
		},
		setFormStorage: (state, payload) => {
			state.inventoryData.storageId = payload.id
			state.storage = payload
		},
		setCompleteInfoDetail: (state, payload) => {
			state.completeInfoDetail = payload
		},
		setImages: (state, payload) => {
			state.images = [...payload]
		},
		setImagesByIndex: (state, payload) => {
			const { index, file } = payload
			state.images[index] = file
		},
		removeImages: (state, payload) => {
			state.images = state.images.filter((item, itemIndex) => {
				return itemIndex !== payload
			})
		},
		setExpirationDatetime: (state, payload) => {
			state.inventoryData.expireDatetime = payload
		},
	},
	actions: {
		loadCategoryInfo: async ({ commit }, payload) => {
			const { instId, categoryId } = payload
			const response = await categoryAPI.lookupCategoryInfo(
				instId,
				categoryId
			)
			// console.log(response.data)
			commit('setCategoryInfo', response.data)
		},
	},
}

export default index
